module.exports = __webpack_public_path__ + "c5157bb097846d1deb8d1884b572ed6a.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/pattern-1.png
// module id = 1141
// module chunks = 0